<div class="flex h-screen bg-gray-100 font-sans text-sm">
  <!-- Left Sidebar (Inbox) -->
  <aside class="w-64 bg-white border-r flex flex-col p-4 space-y-4">
    <app-left-sidebar></app-left-sidebar>
  </aside>

  <!-- Main Content -->
  <main class="flex-1 flex flex-col bg-purple-50 overflow-y-auto">
    <header class="p-4 border-b bg-white">
      <h1 class="text-xl font-bold text-purple-800">Mesečna statistika</h1>
      <p class="text-xs text-gray-500 mt-1">Broj poruka po mesecima</p>
    </header>

    <div class="flex-1 p-6">
      <div class="grid grid-cols-2 gap-4 mb-6 max-w-md">
        <div class="bg-white border rounded-xl shadow-sm p-4">
          <p class="text-xs font-bold uppercase text-gray-500">Ukupno poruka</p>
          <p class="text-2xl font-bold text-purple-700 mt-1">{{ totalRecords() | number }}</p>
        </div>
        <div class="bg-white border rounded-xl shadow-sm p-4">
          <p class="text-xs font-bold uppercase text-gray-500">Broj meseci</p>
          <p class="text-2xl font-bold text-purple-700 mt-1">{{ stats().length }}</p>
        </div>
      </div>

      <section class="bg-white border rounded-xl shadow-sm overflow-hidden max-w-3xl">
        <table class="w-full">
          <thead class="bg-gray-50 border-b">
            <tr class="text-xs font-bold uppercase text-gray-500">
              <th class="text-left px-5 py-3">Mesec</th>
              <th class="text-right px-5 py-3">Poruke</th>
              <th class="px-5 py-3 w-1/3"></th>
            </tr>
          </thead>
          <tbody class="divide-y">
            @for (stat of sortedStats(); track stat.id) {
              <tr class="hover:bg-purple-50/60 transition-colors">
                <td class="px-5 py-3 font-medium text-gray-700">
                  {{ monthName(stat.record_month) }} {{ stat.record_year }}
                </td>
                <td class="px-5 py-3 text-right font-mono font-bold text-purple-700">
                  {{ stat.total_records | number }}
                </td>
                <td class="px-5 py-3">
                  <div class="h-2 bg-purple-100 rounded-full overflow-hidden">
                    <div
                      class="h-full bg-purple-500 rounded-full"
                      [style.width.%]="maxRecords() ? (stat.total_records / maxRecords()) * 100 : 0"
                    ></div>
                  </div>
                </td>
              </tr>
            } @empty {
              <tr>
                <td colspan="3" class="px-5 py-8 text-center text-gray-400">Nema podataka.</td>
              </tr>
            }
          </tbody>
        </table>
      </section>
    </div>
  </main>
</div>
